import React from "react";

export const SectionHeader = ({ kicker, title, description, align = "left", id }) => {
  const alignClass = align === "center" ? "items-center text-center" : "items-start";
  return (
    <div className={`flex flex-col ${alignClass} max-w-3xl ${align === "center" ? "mx-auto" : ""}`} id={id}>
      {kicker && (
        <div className="flex items-center gap-3 mb-4">
          <span className="block w-10 h-[2px] bg-[#E60000]" />
          <span className="font-display text-xs tracking-[0.4em] text-[#FFCC00]">
            {kicker}
          </span>
        </div>
      )}
      <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white leading-[0.95]">
        {title}
      </h2>
      {description && (
        <p className="mt-5 text-[#d4d4d8] text-base sm:text-lg leading-relaxed">
          {description}
        </p>
      )}
    </div>
  );
};

export default SectionHeader;
